var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSucces(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7058 71.9997H21.1764C21.1764 70.603 21.1764 48.0882 21.1764 46.5879H12.7058V71.9997Z",
    fill: "#086CF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4116 72.0006H33.8822C33.8822 70.6769 33.8822 44.3311 33.8822 42.3535H25.4116V72.0006Z",
    fill: "#086CF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0003 21.1765L64.0591 10.5882L72.0003 0C70.5744 0 45.777 0 44.4709 0V38.1176H38.1179V72H55.0591V38.1176H48.7062V21.1765H72.0003Z",
    fill: "#086CF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47059 50.8232H0V71.9997H8.47059C8.47059 71.0221 8.47059 51.7974 8.47059 50.8232Z",
    fill: "#086CF9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucces);
export default __webpack_public_path__ + "static/media/succes.1f5f958093ebd151d41bf920edbf256b.svg";
export { ForwardRef as ReactComponent };